/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonResumeeModifyGradeBatch202,
  PostApiV1PersonResumeeModifyGradeBatch400,
  PostApiV1PersonResumeeModifyGradeBatch401,
  PostApiV1PersonResumeeModifyGradeBatch500,
  PostApiV1PersonResumeeModifyGradeBatchMutationRequest,
  PostApiV1PersonResumeeModifyGradeBatchMutationResponse,
} from "../../types/personResumeeController/PostApiV1PersonResumeeModifyGradeBatch.ts";
import { classroomUserModifyGradeManualRequestViewModelSchema } from "../classroomUserModifyGradeManualRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1PersonResumeeModifyGradeBatch202Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeModifyGradeBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonResumeeModifyGradeBatch400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeModifyGradeBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonResumeeModifyGradeBatch401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeModifyGradeBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonResumeeModifyGradeBatch500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeModifyGradeBatch500>;

export const postApiV1PersonResumeeModifyGradeBatchMutationRequestSchema =
  z.lazy(
    () => classroomUserModifyGradeManualRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1PersonResumeeModifyGradeBatchMutationRequest>;

export const postApiV1PersonResumeeModifyGradeBatchMutationResponseSchema =
  z.lazy(
    () => postApiV1PersonResumeeModifyGradeBatch202Schema,
  ) as unknown as ToZod<PostApiV1PersonResumeeModifyGradeBatchMutationResponse>;
